import { render } from "./IconSuccess.vue?vue&type=template&id=ba156b1e"
import script from "./IconSuccess.vue?vue&type=script&lang=js"
export * from "./IconSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__